import axios from "axios";

// Helper to get base URL from env
const getTmaxBaseUrl = () => process.env.REACT_APP_TMAX_BASE_URL || process.env.TMAX_BASE_URL || "http://localhost:8090";

// We can use a separate axios instance or just fetch, but let's stick to a simple helper or use the existing api instance if it supported external URLs (usually axios instances are bound to a baseURL).
// Since TMAX URL is different from the main backend, we should creat a new instance or just use axios directly.

export const checkTmaxHealth = async () => {
    try {
        const response = await axios.get(`${getTmaxBaseUrl()}/api/health`);
        return response.data;
    } catch (error) {
        console.error("TMAX Health Check Error:", error);
        throw error;
    }
};

export const startTmaxSession = async (tmaxId: number | string, minutes: number, delay: number = 0) => {
    try {
        const response = await axios.post(`${getTmaxBaseUrl()}/api/rooms/${tmaxId}/start?minutes=${minutes}&delay=${delay}`);
        return response.data;
    } catch (error) {
        console.error("TMAX Start Session Error:", error);
        throw error;
    }
};

export const cancelTmaxSession = async (tmaxId: number | string) => {
    try {
        const response = await axios.post(`${getTmaxBaseUrl()}/api/rooms/${tmaxId}/cancel`);
        return response.data;
    } catch (error) {
        console.error("TMAX Cancel Session Error:", error);
        throw error;
    }
};
